export default __webpack_public_path__ + "static/metrics_01-8741bb05b9161e5fd2612f6e476e0ffa.png";